export default {
  UPDATE_USER_DETAILS(state, payload) {
    state.userDetails = payload
  },

  UPDATE_USER_MODELS(state, payload) {
    state.usersModels = payload
  }
}
